<template>
  <yi-cart-list @createOrder="handleCreateOrder"></yi-cart-list>
</template>

<script>
export default {
  name: 'cart',
  methods: {
    handleCreateOrder(orderForm) {
      const createOrderUrl = `/demo/packageMall/newOrder?orderForm=${JSON.stringify(orderForm)}`;
      uni.navigateTo({
        url: createOrderUrl,
      });
    },
  },
};
</script>

<style scoped></style>
